import { render, staticRenderFns } from "./DialogAddTask.vue?vue&type=template&id=dd48af44&"
import script from "./DialogAddTask.vue?vue&type=script&lang=js&"
export * from "./DialogAddTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd48af44')) {
      api.createRecord('dd48af44', component.options)
    } else {
      api.reload('dd48af44', component.options)
    }
    module.hot.accept("./DialogAddTask.vue?vue&type=template&id=dd48af44&", function () {
      api.rerender('dd48af44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddTask.vue"
export default component.exports